import ContactInformation from "@/components/data-display/card/contactInformation";
import LocationUrlCard from "@/components/data-display/card/locationUrlCard";
import PageBanner from "@/components/data-display/pageBanner";
import ContactUsForm from "@/components/data-input/form/contactUsForm";
import MetaData from "@/components/seo/MetaData";

function Contact() {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_ABSOLUTE_URL}/contact`;

  return (
    <>
      <MetaData url={pageUrl} />
      <PageBanner bannerText="Contact Us" />

      <div className="md:mt[8rem] container mt-[3rem]">
        <div className="flex flex-col gap-[3rem] md:flex-row ">
          <div className="w-full lg:w-[60%]">
            <ContactUsForm />
          </div>
          <div className="md:mt-[6rem]">
            <ContactInformation />
          </div>
        </div>
        <div className="mb-[5.68rem] mt-[4rem]">
          <LocationUrlCard />
        </div>
      </div>
    </>
  );
}

export default Contact;
